const TRANSACTION_STATE = {
  RECEIPT: 1,
  PAYMENT: 2,
};

export default TRANSACTION_STATE;
